import { baseApi } from '../../../shared/api/baseApi';
import type { ApiPath } from '../../../shared/api/types';
import type { OrganizationLimitDto } from '../model/dto';
import { toRequestLimit } from '../model/mappers';
import type { RequestLimit } from '../model/types';

const TAG = 'RequestLimit' as const;

export interface RequestLimitArgs {
    organizationId: string;
    admin: boolean;
}

export const limitsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({

        getRequestLimit: build.query<RequestLimit, RequestLimitArgs>({
            query: ({ organizationId, admin }) =>
                (admin
                    ? `/api/admin/organizations/${organizationId}`
                    : `/api/organizations/${organizationId}`) as ApiPath,
            transformResponse: (response: OrganizationLimitDto) => toRequestLimit(response),
            providesTags: (_result, _error, { organizationId }) => [{ type: TAG, id: organizationId }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetRequestLimitQuery } = limitsApi;